import React, { ReactNode, ReactNodeArray } from 'react';
import BusinessMonitoringCharts from './BusinessMonitoringCharts'
import BusinessMonitoringChartsBlockData from '../../../Models/Content/BusinessMonitoringChartsBlockData';
import EpiComponent from '@episerver/spa-core/EpiComponent';


export default class BusinessMonitoringChartsBlock extends EpiComponent<BusinessMonitoringChartsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = [];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <BusinessMonitoringCharts iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}



